// 日時からランダムな
export function createNumberForDateTime () {
  let date = new Date();
  return date.toISOString().replace(/[^0-9]/g, '');
}